import axios from "axios";

const create = payload =>
  axios.post("/api/v1/archival_data", { archival_data: payload });

const list = () => axios.get("/api/v1/archival_data");

const search = term => axios.get(`/api/v1/archival_data/search?term=${term}`);

const advancedSearch = (term, fields) => {
  const params = new URLSearchParams();
  params.set("term", term);
  fields.forEach((field, index) => params.set(`fields[${index}]`, field));
  return axios.get(`/api/v1/archival_data/advanced_search?${params}`);
};

const viewPdf = payload =>
  axios.post(
    "/api/v1/archival_data/view_pdf",
    { archival_data: payload },
    { responseType: "blob" }
  );
const archivalDataApi = { create, list, search, advancedSearch, viewPdf };

export default archivalDataApi;
